import ApiConnector from '@/backend/apiModels/CRUDrequest'
import { createToaster } from "@meforma/vue-toaster";

const toaster = createToaster();
const api = new ApiConnector('applications')
const namespaced = true

const state = {
  applications:[],
  currentApp:{}
};

const mutations = {
  setApplication(state, value){
    state.applications.push(value)
    state.currentApp = value
  },
};

const getters = {
  getCurrentInstance(state) {
    return state.currentApp
  },
  // при желании можно оформить и как геттер
  applicationByTripId: (state) => (trip_id) => {
    return state.applications.find(app => app.trip_id === trip_id)
  }
};

const actions = {
  async getApplication(ctx,trip_id){
    const { response, request } = api.get('/'+trip_id,{params:{}})
    await request()
    ctx.commit('setApplication', response.value)
    console.log(response.value)
    return response.value
  },

  getApplicationIsSend({ state }, trip_id) {
    const app = state.applications.find(a => a.trip_id === trip_id)
    return app
  }

};

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};